var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('AntecedenteComponent',{model:{value:(_vm.grupos),callback:function ($$v) {_vm.grupos=$$v},expression:"grupos"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }